const appDrawerWidth = 240;

export default appDrawerWidth;
